import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogOut = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.80267 0.494243C5.56467 0.215576 4.66667 1.27958 4.66667 2.33158V11.6649C4.66667 12.7169 5.56467 13.7809 6.80267 13.5022C9.77733 12.8329 12 10.1756 12 6.99824C12 3.82091 9.77733 1.16358 6.80267 0.494243ZM3.138 4.52691C3.01298 4.40193 2.84344 4.33172 2.66667 4.33172C2.48989 4.33172 2.32035 4.40193 2.19533 4.52691L0.195333 6.52691C0.0703516 6.65193 0.000142097 6.82147 0.000142097 6.99824C0.000142097 7.17502 0.0703516 7.34456 0.195333 7.46958L2.19533 9.46958C2.32107 9.59102 2.48947 9.65821 2.66427 9.65669C2.83906 9.65517 3.00627 9.58506 3.12988 9.46146C3.25348 9.33785 3.3236 9.17064 3.32512 8.99584C3.32664 8.82105 3.25944 8.65265 3.138 8.52691L2.276 7.66491H8C8.17681 7.66491 8.34638 7.59467 8.4714 7.46965C8.59643 7.34462 8.66667 7.17505 8.66667 6.99824C8.66667 6.82143 8.59643 6.65186 8.4714 6.52684C8.34638 6.40181 8.17681 6.33158 8 6.33158H2.276L3.138 5.46958C3.26298 5.34456 3.33319 5.17502 3.33319 4.99824C3.33319 4.82147 3.26298 4.65193 3.138 4.52691Z",
		fill: "currentColor"
	})
});
export default SvgLogOut;
